import React, { FC } from "react";
import { Box, BoxProps } from "theme-ui";
import { KameleonIcon } from "@kameleon-common/icons";

export type IconMediumType = {
  icon: string;
  hasBg?: boolean;
  noPrimary?: boolean;
} & BoxProps;

export const IconMedium: FC<IconMediumType> = ({
  icon,
  hasBg,
  noPrimary,
  ...props
}: IconMediumType) => (
  <Box
    variant="icons.sizes.medium"
    {...props}
    sx={{
      backgroundColor: hasBg ? "bg.icon" : "transparent",
      color: noPrimary ? "inherit" : "primary",
      width: "4rem",
      height: "4rem",
      ...props.sx,
    }}
  >
    <KameleonIcon name={icon} />
  </Box>
);

IconMedium.defaultProps = {
  hasBg: true,
  noPrimary: false,
};
